import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import LoadingComponent from '../components/loading/LoadingComponent';
import AuthServices from '../services/AuthServices';
import { Navigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import logsUserService from '../services/UserLogServices';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [token, setToken] = useState(null);
    const [email, setEmail] = useState(null);
    const initialized = useRef(false); // Usar useRef para controlar la inicialización

    useEffect(() => {
        const initializeAuth = async () => {
            console.log('Initializing auth...');

            const storedToken = sessionStorage.getItem('token');
            const storedEmail = sessionStorage.getItem('email');

            if (storedToken && storedEmail) {
                setToken(storedToken);
                setEmail(storedEmail);
                setIsLoading(false);
                return;
            }

            const urlParams = new URLSearchParams(window.location.search);
            const emailFromUrl = urlParams.get('email');

            if (emailFromUrl) {
                console.log('Email from URL:', emailFromUrl);
                try {
                    const results = await AuthServices(emailFromUrl);
                    console.log('AuthServices response:', results);

                    if (results) {
                        Swal.fire({
                            toast: true,
                            position: 'top-end',
                            icon: 'success',
                            title: 'Sesión exitosa, cargando...',
                            customClass: {
                                title: "text-center"
                            },
                            showConfirmButton: false,
                            timer: 2500,
                            timerProgressBar: true,
                            willClose: () => {
                                const userData = {
                                    user_Id: results['id_user'],
                                    action: 'login SciennceTv',
                                    urlCampaign: window.location.href
                                };

                                logsUserService(userData.user_Id, userData.action, userData.urlCampaign);
                                sessionStorage.setItem('token', results['access']);
                                sessionStorage.setItem('name', results['name']);
                                sessionStorage.setItem('country', results['country']);
                                sessionStorage.setItem('city', results['city']);
                                sessionStorage.setItem('email', results['email']);
                                sessionStorage.setItem('last_name', results['last_name']);
                                sessionStorage.setItem('id_user', results['id_user']);
                                sessionStorage.setItem('email', emailFromUrl);
                                sessionStorage.setItem('id_event', results['eventInscribed']);
                                window.location.replace('/inicio');
                            }
                        });

                        setToken(results['access']);
                        setEmail(emailFromUrl);

                        // Clear URL parameters
                        const newUrl = window.location.origin + window.location.pathname;
                        window.history.replaceState({}, document.title, newUrl);
                    }
                } catch (error) {
                    console.error('Auth error:', error);
                }
            }

            setIsLoading(false);
        };

        if (!initialized.current) { // Verificar si ya se inicializó
            initializeAuth();
            initialized.current = true; // Marcar como inicializado
        }
    }, []); // Asegúrate de que no hay dependencias aquí

    const logout = () => {
        setToken(null);
        setEmail(null);
        sessionStorage.clear();
    };

    if (isLoading) {
        return <LoadingComponent text={'redirigiendo'} />;
    }

    return (
        <AuthContext.Provider value={{ token, email, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export function RequireAuth({ children }) {
    const token = sessionStorage.getItem('token');

    if (!token) {
        return <Navigate to="/home" />;
    }
    return children;
}
